import React from 'react';
import { LogoContainer } from '@components/common/logo';
import { Nav, StyledHero } from './ErrorHero';

export const ErrorBlank = () => {
  return (
    <StyledHero
      src={'/assets/images/error/error-401.jpg'}
      renderTop={
        <Nav>
          <LogoContainer />
        </Nav>
      }
    />
  );
};
